import { render, staticRenderFns } from "./StudentDataManagementList.vue?vue&type=template&id=92fd5a22"
import script from "./StudentDataManagementList.vue?vue&type=script&lang=js"
export * from "./StudentDataManagementList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports